import { render, staticRenderFns } from "./SubscriptionsBlock.vue?vue&type=template&id=6f363265&scoped=true"
import script from "./SubscriptionsBlock.vue?vue&type=script&lang=ts"
export * from "./SubscriptionsBlock.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionsBlock.vue?vue&type=style&index=0&id=6f363265&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f363265",
  null
  
)

export default component.exports